/* eslint-disable */
export const speakers = [{
    id: '1ca57305-2591-4855-8cf4-25c970ef0265',
    company: 'Accenture',
    country: 'Germany',
    featured: false,
    isConfirmed: true,
    longDesc: 'Vitali leads the Legacy Transformation solution in EMEA and serves as the Global Pega Enablement Lead at Accenture. With over eight years of hands-on experience in Pega, he combines deep business and technical expertise to guide organizations on their transformation journeys toward modern, scalable Pega applications. Throughout his career at Accenture, Vitali has helped clients modernize their processes, enhance ways of working, and embed enablement into change management initiatives. As a certified Pega Lead Decisioning Architect, he specializes in transforming marketing and communication strategies through real-time decisioning and AI-driven engagement.',
    name: 'Vitali Graf',
    photo: 'https://www.openslava.sk/images/2025/vitali_graf_1ca57305-2591-4855-8cf4-25c970ef0265.jpg',
    shortDesc: 'Vitali leads the Legacy Tra...',
    order: 0,
    talks: ['10634fb1-455c-4c01-800f-0c23b891365c','f24252ab-90d6-4be9-b216-0654ca568c18']
  },
  {
    id: 'affac4e0-f6b2-48e0-983b-1e0fa990462a',
    company: 'Accenture',
    country: 'Romania',
    featured: true,
    isConfirmed: true,
    longDesc: 'Catalin is Head of the AI & ML in ATC EMEA CE. He leads the design and delivery of AI solutions with a focus on scalable architectures in many sectors especially automotive. Catalin combines deep technical expertise with leadership in large-scale projects, RFPs, and AI strategy.',
    name: 'Catalin Novac',
    photo: 'https://www.openslava.sk/images/2025/catalin_novac_affac4e0-f6b2-48e0-983b-1e0fa990462a.jpg',
    shortDesc: 'Catalin is Head of the AI &...',
    order: 5,
    talks: ['cb3cfb24-a24d-4fac-b838-36590aea7d53']
  },
  {
    id: 'e513519e-497d-4792-8aca-d14343c555f3',
    company: 'Accenture',
    country: 'Austria',
    featured: false,
    isConfirmed: true,
    longDesc: 'Rudolf is a certified Technology Architect in the Cloud Advisory & Design Enterprise Architecture group for work and a hoppy tennis player who recently got into CrossFit in his free time. He has experience in custom developing solutions and Cloud-native technologies in the automotive industry and is currently delivering a custom platform solution in the public sector.',
    name: 'Rudolf Rosenfeld',
    photo: 'https://www.openslava.sk/images/2025/rudolf_rosenfeld_e513519e-497d-4792-8aca-d14343c555f3.jpg',
    shortDesc: 'Rudolf is a certified Techn...',
    order: 0,
    talks: ['4eb25b8b-4068-426d-8552-8cbe804bf275']
  },
  {
    id: '9b8a41a7-1ee9-47e3-b3b9-7ff2211a867f',
    company: 'Bowbridge',
    country: 'Germany',
    featured: false,
    isConfirmed: true,
    longDesc: 'Chief Technology Officer & Co-Founder, Bowbridge',
    name: 'Joerg Schneider Simon',
    photo: 'https://www.openslava.sk/images/2025/joerg_schneider simon_9b8a41a7-1ee9-47e3-b3b9-7ff2211a867f.jpg',
    shortDesc: 'Chief Technology Officer & ...',
    order: 0,
    talks: ['9b024ba2-118f-488e-9411-b983a01c4107']
  },
  {
    id: '2251d145-b8e0-4bd5-a53c-5b8c91f54b76',
    company: 'Accenture',
    country: 'Slovakia',
    featured: false,
    isConfirmed: true,
    longDesc: 'Miro is a Full-Stack and Generative AI Developer with a background in XR technologies (VR, AR). Since joining Accenture in 2021, he has transitioned from immersive solutions to projects in generative artificial intelligence, focusing on end-to-end development. He hold`s a degree in Intelligent Software Systems from STU FIIT in Bratislava.',
    name: 'Miroslav Kozma',
    photo: 'https://www.openslava.sk/images/2025/miroslav_kozma_2251d145-b8e0-4bd5-a53c-5b8c91f54b76.jpg',
    shortDesc: 'Miro is a Full-Stack and Ge...',
    order: 0,
    talks: ['cb3cfb24-a24d-4fac-b838-36590aea7d53']
  },
  {
    id: '0afa31f1-e1c5-4fc9-8fc2-4e3861dbc7ef',
    company: 'DAITABLE',
    country: 'Slovakia',
    featured: false,
    isConfirmed: true,
    longDesc: 'Šimon Staňo is the CEO and co-founder of DAITABLE, a company transforming how organizations harness real-time data to make smarter, cost-saving decisions. With a background in data science and business innovation, Šimon has dedicated his career to bridging advanced AI with practical applications in energy management, industrial operations, and commercial buildings. Under his leadership, DAITABLE has helped clients optimize performance, reduce waste, and unlock measurable financial and sustainability gains. A passionate advocate for data-driven decision-making, Šimon speaks internationally on the future of AI, energy intelligence, and how technology can deliver both economic and environmental impact.',
    name: 'Šimon Staňo',
    photo: 'https://www.openslava.sk/images/2025/šimon_staňo_0afa31f1-e1c5-4fc9-8fc2-4e3861dbc7ef.jpg',
    shortDesc: 'Šimon Staňo is the CEO and ...',
    order: 0,
    talks: ['5b2a9ec8-da9c-4db3-b8cb-3f96b804ff75']
  },
  {
    id: '6421e779-7c1e-40c8-8d05-88ba9949e2d6',
    company: 'Erste Digital',
    country: 'Slovakia',
    featured: false,
    isConfirmed: true,
    longDesc: 'Platform automation wizard with over decade of infrastructure and engineering experience. Passionate best practices advocate and relentless learner.',
    name: 'Pavel Kestefran',
    photo: 'https://www.openslava.sk/images/2025/pavel_kestefran_6421e779-7c1e-40c8-8d05-88ba9949e2d6.jpg',
    shortDesc: 'Platform automation wizard ...',
    order: 0,
    talks: ['de9ade6d-2f51-44ae-8f9f-bb630b72aa9e']
  },
  {
    id: '021051c7-2943-4676-9c60-f143d030d9c2',
    company: 'Accenture',
    country: 'United States',
    featured: false,
    isConfirmed: true,
    longDesc: 'Pavol is a Cloud Advisory Managing Director at Accenture in the United States, but he`s originally from Slovakia. Among other things, he co-founded OpenSlava, the very same IT conference you`re about to attend. Pavol working on high-profile projects for Fortune 500 companies, always passionate about helping clients get to Cloud Native Architectures and enabling all teams embrace Modern Engineering Practices.',
    name: 'Pavol Szorad',
    photo: 'https://www.openslava.sk/images/2025/pavol_szorad_021051c7-2943-4676-9c60-f143d030d9c2.jpg',
    shortDesc: 'Pavol is a Cloud Advisory M...',
    order: 0,
    talks: ['092b9100-89b4-44f7-b5b9-7dac375dc1db','a0025aa6-e05c-4b49-8690-ca53a202237a','ea3c32dc-2d00-4322-9365-6c1d630f4150']
  },
  {
    id: '03255126-a9e1-4873-a5c4-d6ab97a6d207',
    company: 'Accenture',
    country: 'Spain',
    featured: false,
    isConfirmed: true,
    longDesc: 'Director of Software Engineering, Architecture, Platform Engineering and DevOps Lead, Advanced Technology Center in Spain. Java Champion.',
    name: 'Jorge Hidalgo',
    photo: 'https://www.openslava.sk/images/2025/jorge_hidalgo_03255126-a9e1-4873-a5c4-d6ab97a6d207.jpg',
    shortDesc: 'Director of Software Engine...',
    order: 0,
    talks: ['0d26e13c-fd89-4999-9e8c-8fc491a58bd5','d045c782-cfbf-4ca8-b16f-27563a53ebcb','f0f4fb9a-c327-46ea-9fae-5d1c9ac052bd']
  },
  {
    id: 'f4d7cc2e-a9dc-4faf-9e46-94a803dff6c1',
    company: 'Amazon Web Services',
    country: 'Germany',
    featured: true,
    isConfirmed: true,
    longDesc: 'Marcel Törpe is Principal Solutions Architect at AWS based in Germany. He supports AWS Partner Network (APN) Consulting Partners defining and developing solutions for customers to drive adoption of the AWS platform. He`s especially passionate about latest innovations such as in generative AI.',
    name: ' Marcel Törpe',
    photo: 'https://www.openslava.sk/images/2025/_marcel törpe_f4d7cc2e-a9dc-4faf-9e46-94a803dff6c1.jpg',
    shortDesc: 'Marcel Törpe is Principal S...',
    order: 80,
    talks: ['67560544-5991-476e-8060-50303ae6d1a9','8cd49786-83d5-4f5f-9762-065891a4d92b']
  },
  {
    id: '2c5c1370-d9f7-4a16-9ec9-3fd7c4f9690f',
    company: 'Accenture',
    country: 'Romania',
    featured: false,
    isConfirmed: true,
    longDesc: 'Stefan Mihai is a Machine Learning Technical Lead, currently driving Generative AI projects with a focus on applied image generation. Beyond leading engineering efforts, he contributes as an ML Architect, designing solutions for both active projects and RFPs. Stefan`s work combines technical leadership with practical implementation to advance the use of AI in real-world applications.',
    name: 'Stefan Mihai',
    photo: 'https://www.openslava.sk/images/2025/stefan_mihai_2c5c1370-d9f7-4a16-9ec9-3fd7c4f9690f.jpg',
    shortDesc: 'Stefan Mihai is a Machine L...',
    order: 0,
    talks: ['cb3cfb24-a24d-4fac-b838-36590aea7d53']
  },
  {
    id: '6a3a376e-c87f-45c1-a235-60f59298c089',
    company: 'Accenture',
    country: 'Slovakia',
    featured: false,
    isConfirmed: true,
    longDesc: 'Adrian has got over 9 years of ServiceNow implementation experience, and overall 20+ years IT experience. Adrian studied AI at the Technical University of Kosice. Apart from his roles as a stream lead in ServiceNow projects, he likes to be involved in implementation projects focusing on Generative AI for large enterprise customers recently.',
    name: ' Adrian Toth',
    photo: 'https://www.openslava.sk/images/2025/_adrian toth_6a3a376e-c87f-45c1-a235-60f59298c089.jpg',
    shortDesc: 'Adrian has got over 9 years of ServiceNow impl...',
    order: 0,
    talks: ['8c353f36-2123-4796-a30d-f1366ff5cd9c']
  },
  {
    id: 'a65c113f-0540-4381-93db-f3f011d9951c',
    company: 'Swiss Re',
    country: 'Slovakia',
    featured: false,
    isConfirmed: true,
    longDesc: 'Matej Banyi is Undewritng Analyst at leading re/insurance company Swiss Re with over a decade of experience in facultative direct and re-insurance risks handling across EMEA region in various lines of business, enabling underwriters to make informed, strategic decisions. He is currently leveraging this foundation as the SME and tester for holistic AI integration into the various stages of insurance policy lifecycle handling processes. ',
    name: 'Matej Banyi',
    photo: 'https://www.openslava.sk/images/2025/matej_banyi_a65c113f-0540-4381-93db-f3f011d9951c.jpg',
    shortDesc: 'Matej Banyi is Undewritng A...',
    order: 0,
    talks: ['092b9100-89b4-44f7-b5b9-7dac375dc1db','27032667-35ff-4685-b3d5-f9bd40ac575e']
  },
  {
    id: '39beeaa9-1423-4aad-9e0c-6a34ebf4557e',
    company: 'Siemens Healthineers',
    country: 'Slovakia',
    featured: true,
    isConfirmed: true,
    longDesc: 'Miroslav Merčiak, certified software architect at Siemens Healthineers, with 19-year experience in this organization. He spent half of this time in developer and senior developer positions, then dedicated next decade to software architecture and software craft. As a driver of software craft initiative in his Computed Tomography team he conducted over 150 “learning-hour“ and DOJO sessions passing his passion for healthy code and continuous learning to his colleagues.',
    name: 'Miroslav Merčiak',
    photo: 'https://www.openslava.sk/images/2025/miroslav_merčiak_39beeaa9-1423-4aad-9e0c-6a34ebf4557e.jpg',
    shortDesc: 'Miroslav Merčiak, certified...',
    order: 60,
    talks: ['e8c5684c-c1b7-4c2a-a0bd-e2c603270b9a']
  },
  {
    id: '25cd3339-d98a-47d6-9d3f-2aa759eb4710',
    company: 'Accenture',
    country: 'Slovakia',
    featured: false,
    isConfirmed: true,
    longDesc: 'Peter is a frontend developer experienced in Angular and React. He joined Accenture in 2018. Currently he`s learning Linux in his free time.',
    name: 'Peter Macko',
    photo: 'https://www.openslava.sk/images/2025/peter_25cd3339-d98a-47d6-9d3f-2aa759eb4710.jpg',
    shortDesc: 'Peter is a frontend develop...',
    order: 0,
    talks: ['debb4aa0-37db-4d87-8c94-2bcf2dfedbcb']
  },
  {
    id: '00804265-6f24-44a7-9f00-218b52c2b651',
    company: 'Allianz Commercial',
    country: 'USA',
    featured: true,
    isConfirmed: true,
    longDesc: 'Max Deingruber is an Executive Underwriting Integrity Manager at Allianz Commercial. With a decade of experience in the insurance industry, Max has gained broad exposure across multiple Lines of Business, specializing in underwriting governance and Financial Lines underwriting. Max drives system-based and automated governance solutions and supports global risk oversight and strategic decision-making through data-driven analysis in his daily work.',
    name: 'Max Deingruber',
    photo: 'https://www.openslava.sk/images/2025/max_deingruber_00804265-6f24-44a7-9f00-218b52c2b651.jpg',
    shortDesc: 'Max Deingruber is an Execut...',
    order: 37,
    talks: ['c9f45e3f-1acc-4370-8a9d-88d2ca50d9df','f24252ab-90d6-4be9-b216-0654ca568c18']
  },
  {
    id: 'bcaa712f-43e8-4e2e-8c0e-a3aafb5680e2',
    company: 'Klein Vision',
    country: 'Slovakia',
    featured: false,
    isConfirmed: true,
    longDesc: 'Stefan is an inventor of AirCar flying car. He is a visionary designer and flying enthusiast. Stefan lectures transportation design at VSVU in Bratislava.  ',
    name: 'Stefan Klein',
    photo: 'https://www.openslava.sk/images/2025/stefan_klein_bcaa712f-43e8-4e2e-8c0e-a3aafb5680e2.jpg',
    shortDesc: 'Stefan is an inventor of Ai...',
    order: 0,
    talks: ['8ccf5e5b-0413-4679-86bd-0c936ac0faa1']
  },
  {
    id: '5be43200-0a62-4dd8-8642-7de901f2e529',
    company: 'Accenture',
    country: 'Czech Republic',
    featured: false,
    isConfirmed: true,
    longDesc: 'Senior cybersecurity leader experienced in securing complex business transformations for enterprise clients across all industries. Main focus is on securing applications/products during their development lifecycle and the infrastructure they are deployed with the objective of helping clients to manage business risks linked to cybersecurity while delivering business value and serving their customers at scale and at speed. Over 20 years of experience in AI, Cybersecurity, Service Management, and Product and Project Management. Holding several industry certifications such as CISM, CISSP, ISO20k Lead Auditor, PCI-DSS, ITIL, PMP, and Product Management, Karel has a robust technical background and a PhD in Cybernetics and Artificial Intelligence from Czech Technical University.',
    name: 'Karel Kohout',
    photo: 'https://www.openslava.sk/images/2025/karel_kohout_5be43200-0a62-4dd8-8642-7de901f2e529.jpg',
    shortDesc: 'Senior cybersecurity leader...',
    order: 0,
    talks: ['3045aa65-acd5-458c-b850-133de42ceb7f']
  },
  {
    id: '31fc111d-32a6-4813-a0d1-854e8fe00e3e',
    company: 'Seznam.cz Slovensko',
    country: 'Slovakia',
    featured: false,
    isConfirmed: true,
    longDesc: 'Jozef leads a Machine Learning engineering team. His background in big data systems led him into ML development. He has worked on advertising systems and now focuses on building products to deliver smarter, more relevant user experiences.',
    name: 'Jozef Štyrák',
    photo: 'https://www.openslava.sk/images/2025/jozef_štyrák_31fc111d-32a6-4813-a0d1-854e8fe00e3e.jpg',
    shortDesc: 'Jozef leads a Machine Learn...',
    order: 0,
    talks: ['6e4609d0-24bd-4b72-ab4f-59c8785d332a']
  },
  {
    id: '808762d8-e990-405c-85b0-6def2cd19d7c',
    company: 'Accenture',
    country: 'Netherlands',
    featured: false,
    isConfirmed: true,
    longDesc: 'Ted van der Voorde is an Enterprise Architect in the Global Architect Excellence group at Accenture, with extensive experience in cloud architecture across Microsoft Azure, Oracle Cloud, and others. Skilled in designing and building application platforms and leading complex cloud migration efforts, with a strong focus on security, automation, and containerization. ',
    name: 'Ted van der Voorde',
    photo: 'https://www.openslava.sk/images/2025/ted_van der voorde_808762d8-e990-405c-85b0-6def2cd19d7c.jpg',
    shortDesc: 'Ted van der Voorde is an En...',
    order: 0,
    talks: ['9020cbfd-d0c1-4417-842b-a7f23cafd36b']
  },
  {
    id: '8f68106c-73b1-4292-b331-c80b8bca03c1',
    company: 'Accenture',
    country: 'Germany',
    featured: false,
    isConfirmed: true,
    longDesc: 'Vlad Larichev leads Industrial AI at Accenture Industry X, focusing on how AI transforms the way we design, build, and operate products across their lifecycle. He works on scalable, trustworthy AI solutions in complex industrial settings and develops the concept of a digital reasoning thread – a logic layer connecting tools, data, and decisions. Vlad explores how AI moves beyond chatbots toward agentic, multimodal systems that perceive, reason, and act in the real world – and what this means for the future of work in engineering, manufacturing, and how companies must adapt.',
    name: 'Vlad Larichev',
    photo: 'https://www.openslava.sk/images/2025/vlad_larichev_8f68106c-73b1-4292-b331-c80b8bca03c1.jpg',
    shortDesc: 'Vlad Larichev leads Industr...',
    order: 0,
    talks: ['a1482ee6-4577-4d0a-b471-60d8a4252fa2']
  },
  {
    id: '50c7b9b3-c5d4-4736-ae7c-2c33122420a6',
    company: 'Accenture',
    country: 'Czech Republic ',
    featured: false,
    isConfirmed: true,
    longDesc: 'François Mariel, security Senior Manager at Accenture Security and EU Platform Security Market Unit Lead, based in Prague (CZ) with over 15 years of experience in consulting services, François brings deep expertise in project management, IT management, security assessment, and threat and vulnerability management. His career spans leadership roles in SAP. , incident monitoring & Response, and the deployment of global security solutions. Currently, he serves as Global Security Account Lead for a multinational tobacco company and has been leading platform security initiatives for a major food and beverage multinational for more than four years. François holds an MBA in Business Strategy and Economic Intelligence, as well as dual Master’s degrees in Defense and Security Law, and in Penal and Criminal Science.',
    name: 'Francois Mariel ',
    photo: 'https://www.openslava.sk/images/2025/francois_mariel _50c7b9b3-c5d4-4736-ae7c-2c33122420a6.jpg',
    shortDesc: 'François Mariel, security Senior Manager at Ac...',
    order: 0,
    talks: ['9b024ba2-118f-488e-9411-b983a01c4107']
  },
  {
    id: '8deef576-1486-45fd-9f90-57f8ad4b6a43',
    company: 'Swiss Re',
    country: 'Slovakia',
    featured: true,
    isConfirmed: true,
    longDesc: 'Lukas Csoka is Data Science Director at leading re/insurance company Swiss Re, where he leads the strategic development and deployment of AI solutions across the company. With a strong foundation in data science, software engineering and global management, he connects technology with business and delivers innovative solutions with real impact. He focuses on using artificial intelligence to improve decision-making, optimize processes and create new value for clients and partners. Lukas is passionate about the responsible use of AI and building high-performance teams that push the boundaries of what is possible in re/insurance.',
    name: 'Lukas Csoka',
    photo: 'https://www.openslava.sk/images/2025/lukas_csoka_8deef576-1486-45fd-9f90-57f8ad4b6a43.jpg',
    shortDesc: 'Lukas Csoka is Data Science...',
    order: 20,
    talks: ['bbfea846-ce9e-4403-8df3-3cf4d0d2acf3']
  },
  {
    id: 'de2c9102-fe35-4d84-9427-1f20e7837c14',
    company: 'Accenture',
    country: 'Slovakia',
    featured: false,
    isConfirmed: true,
    longDesc: 'Pavel is a senior full-stack developer and technology architect who loves exploring new possibilities by creating new things. His experience stretches from web and mobile to IoT. He is currently enthusiastic about the ecosystem around TypeScript and loves to share his enthusiasm with others.',
    name: 'Pavel Struhár',
    photo: 'https://www.openslava.sk/images/2025/pavel_struhár_de2c9102-fe35-4d84-9427-1f20e7837c14.jpg',
    shortDesc: 'Pavel is a senior full-stac...',
    order: 0,
    talks: ['debb4aa0-37db-4d87-8c94-2bcf2dfedbcb']
  },
  {
    id: '50b9477f-95e7-4a8c-8b6d-672ecb0b2cbd',
    company: 'Accenture',
    country: 'Slovakia',
    featured: false,
    isConfirmed: true,
    longDesc: 'I studied physics at the Faculty of Mathematics and Physics, Comenius University, Bratislava. I work on interesting genAI projects and deliver solutions for the enterprise. This gives me the opportunity to experience first-hand the pros and cons of genAI in the enterprise environment, as well as their advanced design patterns. The opportunity to discuss this on OpenSlave can be an interesting asset. ',
    name: 'Branislav Majerník',
    photo: 'https://www.openslava.sk/images/2025/branislav_majerník_50b9477f-95e7-4a8c-8b6d-672ecb0b2cbd.jpg',
    shortDesc: 'I studied physics at the Fa...',
    order: 0,
    talks: ['d6fa8501-d4fb-45d9-a853-57772d5f0083']
  },
  {
    id: '06eeb599-0c92-4211-b6f9-0defe5e275f8',
    company: 'Accenture',
    country: 'Slovakia',
    featured: false,
    isConfirmed: true,
    longDesc: 'Kristina is a professional and versatile multidisciplinary designer with over 6 years of experience in technology and design. she combines creative thinking with technical expertise to deliver innovative products and solutions, drawing on global collaborations across industries such as consumer, banking, and technology.',
    name: 'Kristina Letkova',
    photo: 'https://www.openslava.sk/images/2025/kristina_letkova_06eeb599-0c92-4211-b6f9-0defe5e275f8.jpg',
    shortDesc: 'Kristina is a professional ...',
    order: 0,
    talks: ['3baaa45f-2df6-4354-86c0-fd17d9a478db']
  },
  {
    id: '46d558c7-28c2-48c7-b355-b1ec9ad9a2bb',
    company: 'Confluent',
    country: 'USA',
    featured: true,
    isConfirmed: true,
    longDesc: 'Adam Tybor is the Global Field CTO at Confluent, where he advises the world’s largest companies on architecting their business for a real-time future. His career has focused on the intersection of data, AI, and cloud strategy, building the platforms that fuel enterprise innovation.  Previously, as Chief Data & AI Architect for Accenture’s Global IT, Adam led the transformation of the company’s own digital core. Now, he helps technology executives move beyond historical analytics to power their own autonomous enterprise, using the streaming data products and AI agent architectures he will discuss today.',
    name: 'Adam Tybor',
    photo: 'https://www.openslava.sk/images/2025/adam_tybor_46d558c7-28c2-48c7-b355-b1ec9ad9a2bb.jpg',
    shortDesc: 'Adam Tybor is the Global Fi...',
    order: 100,
    talks: ['453c7680-77c9-474a-bfd3-d6d0a9a5122f','dc9eaf84-19a0-452a-a2e1-dfed104123dd']
  },
  {
    id: 'bcf0d471-eadf-4996-b19a-c52921cb9655',
    company: 'Seznam.cz Slovensko',
    country: 'Czechia',
    featured: true,
    isConfirmed: true,
    longDesc: 'Petr Kolar has been working as a big data engineer at Seznam.cz for nearly a decade. His expertise spans batch processing frameworks like MapReduce and Apache Spark, as well as real-time data processing with Apache Flink. Petr has successfully led projects to optimize big data pipelines for high-performance environments. Outside of work, he enjoys hiking, traveling, and staying updated on the latest trends in artificial intelligence.',
    name: 'Petr Kolář',
    photo: 'https://www.openslava.sk/images/2025/petr_kolář_bcf0d471-eadf-4996-b19a-c52921cb9655.jpg',
    shortDesc: 'Petr Kolar has been working...',
    order: 50,
    talks: ['8466c0a6-70f5-439e-a45e-af7b6901df2a']
  },
  {
    id: '8d031809-c0cd-4d2f-9cef-93be9347a593',
    company: 'Accenture ',
    country: 'France',
    featured: false,
    isConfirmed: true,
    longDesc: 'Fatima-Zahra is a Robotics Engineer and Developer at Accenture specializing in autonomous robotics, digital twins, and AI-driven learning. Her work focuses on bridging human intention and machine intelligence to shape the future of adaptive, collaborative autonomous robotic systems.',
    name: 'Fatima-Zahra Laftissi',
    photo: 'https://www.openslava.sk/images/2025/fatima-zahra_laftissi_8d031809-c0cd-4d2f-9cef-93be9347a593.jpg',
    shortDesc: 'Fatima-Zahra is a Robotics ...',
    order: 0,
    talks: ['ddeff478-bbc9-42bf-95eb-f05e4197d6be']
  },
  {
    id: '1fcd64ef-c485-4ea7-ae25-9711a90ce2b6',
    company: 'Accenture',
    country: 'France',
    featured: false,
    isConfirmed: true,
    longDesc: 'Luca Schiatti is a Manager in the Data & AI division at Accenture, based in Sophia Antipolis (France). His current focus is on innovating with Accenture clients around Agentic AI, Identity Wallets, and Confidential Computing. Luca joined the Data & AI group in 2024 after more than 10 years as an Applied Researcher at Accenture Labs, where he worked on the incubation and scaling of key technologies including Distributed Ledger, Digital Identity, and Privacy Preserving Computation. He is also a prolific inventor at Accenture, with numerous patents granted in these domains. Luca holds M.Sc. degrees in Computer Engineering, Media Engineering, and Communication Engineering from Politecnico di Milano, Politecnico di Torino, and Télécom ParisTech.',
    name: 'Luca Schiatti',
    photo: 'https://www.openslava.sk/images/2025/luca_schiatti_1fcd64ef-c485-4ea7-ae25-9711a90ce2b6.jpg',
    shortDesc: 'Luca Schiatti is a Manager ...',
    order: 0,
    talks: ['52acf53e-1e93-428e-899a-4a531c45e809']
  },
  {
    id: 'b6c9e111-a7c8-410e-9038-d3d8e0d15d38',
    company: 'Accenture',
    country: 'Ireland',
    featured: true,
    isConfirmed: true,
    longDesc: 'Marie Wallace has spent more than two decades building AI tech across a broad spectrum of use cases and that has fueled her passion for the ethics of data science and technology that empowers individuals with their own data. To that end, she has spent the last eight years working on a variety of decentralized identity use cases that deliver measurable business value, while protecting individuals and giving them agency over their own data. Marie is a globally recognized thought leader, who has been sharing insights for more than a decade on her blog, allthingsanalytics.com. ',
    name: 'Marie Wallace',
    photo: 'https://www.openslava.sk/images/2025/marie_wallace_b6c9e111-a7c8-410e-9038-d3d8e0d15d38.jpg',
    shortDesc: 'Marie Wallace has spent mor...',
    order: 90,
    talks: ['f3673d86-c439-459d-a61c-cd3b9980c8fc']
  },
  {
    id: '0fa0a002-3887-4209-8e1d-c2173930c53a',
    company: 'Accenture',
    country: 'Hungary',
    featured: false,
    isConfirmed: true,
    longDesc: 'Szilard has got over 8 years of ServiceNow implementation experience and is a Certified Technical Architect for ServiceNow. He is a well-recognized member of the ServiceNow Architecture community. Apart from leading an implementation team for a CMDB project for a large software company, he likes to be involved in activities around Generative AI and Agentic AI on the ServiceNow Platform.',
    name: 'Szilard Toth',
    photo: 'https://www.openslava.sk/images/2025/szilard_toth_0fa0a002-3887-4209-8e1d-c2173930c53a.jpg',
    shortDesc: 'Szilard has got over 8 years of ServiceNow imp...',
    order: 0,
    talks: ['8c353f36-2123-4796-a30d-f1366ff5cd9c']
  },
  {
    id: '540cb0b7-19ce-4404-a661-45c3c93ca9c8',
    company: 'Accenture',
    country: 'Germany',
    featured: false,
    isConfirmed: true,
    longDesc: 'Touhidul is a GenAI Solution Engineer at Accenture with over 6+ years of experience delivering NLP/AI solution in different industries. Since last 3 years, he spent most of work focusing on dealing GenAI solution in different phases in multiple sectors. He is passionate about new technological innovation and willing to put this knowledge in practice. ',
    name: 'Touhidul Alam',
    photo: 'https://www.openslava.sk/images/2025/touhidul_alam_540cb0b7-19ce-4404-a661-45c3c93ca9c8.jpg',
    shortDesc: 'Touhidul is a GenAI Solutio...',
    order: 0,
    talks: ['2035a331-6400-4ec9-93b9-c737c8e888b6']
  },
  {
    id: '7de1d2a4-b7c8-4d37-93ac-c5c6022a6035',
    company: 'Kempelen Institute of Intelligent Technologies',
    country: 'Slovakia',
    featured: false,
    isConfirmed: true,
    longDesc: 'Martin Tamajka is a Tech lead at Kempelen Institute of Intelligent Technologies. He focuses on the research of new methods of deep learning, which includes, among other things, current models of natural language processing and increasing the transparency of neural networks through explainability methods and image data analysis. He participated in and led several industrial collaborations and research projects, aimed, among other things, at creating a pan-European platform for AI researchers, analysing historical cultural heritage with the help of artificial intelligence, or increasing the transparency of artificial intelligence models in the context of the fight against disinformation.',
    name: 'Martin Tamajka',
    photo: 'https://www.openslava.sk/images/2025/martin_tamajka_7de1d2a4-b7c8-4d37-93ac-c5c6022a6035.jpg',
    shortDesc: 'Martin Tamajka is a Tech le...',
    order: 0,
    talks: ['737e70fd-321c-40db-b26d-f382b4e0791b']
  },
  {
    id: '830c5b58-84d8-48a9-9817-d66d4a2d8363',
    company: 'Petitpress (SME.sk)',
    country: 'Slovakia',
    featured: false,
    isConfirmed: true,
    longDesc: 'Ondrej Podstupka was born in 1985 in Bratislava. He studied European Studies at the Faculty of Social and Economic Sciences at Comenius University. He got his first opportunity to write in the economics department of TASR. From there, he moved to the economics section of SME and later worked as an editor for sme.sk. He is currently the deputy editor-in-chief for audio, video, and social media. He is a co-host of Klik podcast.',
    name: 'Ondrej Podstupka',
    photo: 'https://www.openslava.sk/images/2025/ondrej_podstupka_830c5b58-84d8-48a9-9817-d66d4a2d8363.jpg',
    shortDesc: 'Ondrej Podstupka was born i...',
    order: 0,
    talks: ['ea3c32dc-2d00-4322-9365-6c1d630f4150']
  },
  {
    id: '5998d346-2dd5-4445-8b51-b5cac45238d9',
    company: 'Accenture',
    country: 'Germany',
    featured: true,
    isConfirmed: true,
    longDesc: 'Juliane Frey is a technology leader with over a decade of experience in enterprise transformation. She focuses on platform strategy, GenAI adoption, and legacy modernization—particularly in financial services. She has shaped initiatives combining intelligent code analysis with low-code delivery, helping clients balance innovation, structure, and speed at scale.',
    name: 'Juliane Frey',
    photo: 'https://www.openslava.sk/images/2025/juliane_frey_5998d346-2dd5-4445-8b51-b5cac45238d9.jpg',
    shortDesc: 'Juliane Frey is a technolog...',
    order: 12,
    talks: ['f24252ab-90d6-4be9-b216-0654ca568c18']
  },
  {
    id: '8d1b9414-d9c2-49a5-abb9-82256fc0204d',
    company: 'Slovak Academy of Sciences / QUTE.sk',
    country: 'Slovakia',
    featured: false,
    isConfirmed: true,
    longDesc: 'A physicist by education - an expert in quantum information processing, quantum technologies and mathematical aspects of quantum foundations and physics. Among other things, he worked on programmable quantum processors, designed quantum voting protocols and mathematical structures. He completed his doctoral studies in 2003 at the Institute of Physics of the Slovak Academy of Sciences and habilitated at Masaryk University in Brno. He received a SCIEX scholarship at ETH Zurich. He is currently the director of the Institute of Physics, where he heads the Research Center for Quantum Information (quantum.physics.sk), and the chairman of the Executive Board of National Center for Quantum Technologies (qute.sk).',
    name: 'Mario Ziman',
    photo: 'https://www.openslava.sk/images/2025/mario_ziman_8d1b9414-d9c2-49a5-abb9-82256fc0204d.jpg',
    shortDesc: 'A physicist by education - ...',
    order: 0,
    talks: ['386ec42d-987c-4ccc-b42e-7875a31444b3']
  },
  {
    id: '32bdaf26-220c-4e36-acd7-a177ae9219d9',
    company: 'Accenture',
    country: 'Belgium',
    featured: false,
    isConfirmed: true,
    longDesc: 'Arnaud is a certified Senior Technology Architect in the Cloud Advisory & Design Enterprise Architecture group by day and serial marathonist by night. He has experience in implementing Cloud-native technologies in the public sector and is currently delivering a custom platform solution at a large public client. Primarily, his focus lies in Infrastructure, but has found deep interest in creating complex end-to-end solutions for our clients and enjoys cracking tough architectural problems.',
    name: 'Arnaud Coel',
    photo: 'https://www.openslava.sk/images/2025/arnaud_coel_32bdaf26-220c-4e36-acd7-a177ae9219d9.jpg',
    shortDesc: 'Arnaud is a certified Senio...',
    order: 0,
    talks: ['4eb25b8b-4068-426d-8552-8cbe804bf275']
  },
  {
    id: '75440e8c-1144-4846-911c-9ee8c6a89222',
    company: 'Accenture',
    country: 'France',
    featured: false,
    isConfirmed: true,
    longDesc: 'Odyssé is a Developer and Robotics Engineer at Accenture, specializing in digital twin environments with Omniverse to simulate and optimize industrial operations involving robots and humans. He delivers 3D simulations and custom solutions while actively engaging with global clients to showcase how robotics and simulation drive efficiency and digital transformation.',
    name: 'Odyssé Loizeau',
    photo: 'https://www.openslava.sk/images/2025/odyssé_loizeau_75440e8c-1144-4846-911c-9ee8c6a89222.jpg',
    shortDesc: 'Odyssé is a Developer and R...',
    order: 0,
    talks: ['ddeff478-bbc9-42bf-95eb-f05e4197d6be']
  },
  {
    id: 'b40fa1dd-759e-4df6-af15-d7e006b5beb5',
    company: 'Accenture',
    country: 'USA',
    featured: true,
    isConfirmed: true,
    longDesc: 'Max is a Global Managing Director leading Accenture’s Cloud Transformation business; advising clients on cloud strategy and laying the architecture and operating model foundation for our clients’ most significant transformations. Max’s teams are responsible for sales and execution, but also R&D and innovation thought leadership to accelerate migration to cloud, modernizing legacy, and adopting future architectures, operating models, and engineering practices.',
    name: 'Max Furmanov',
    photo: 'https://www.openslava.sk/images/2025/max_furmanov_b40fa1dd-759e-4df6-af15-d7e006b5beb5.jpg',
    shortDesc: 'Max is a Global Managing Director leading Acce...',
    order: 150,
    talks: ['3fd550f8-8bea-4ddf-adc7-68fb3661aa3d','453c7680-77c9-474a-bfd3-d6d0a9a5122f']
  },
  {
    id: '3a14d41e-6c58-4c70-8664-df48cfdc5524',
    company: 'Accenture',
    country: 'Slovakia',
    featured: false,
    isConfirmed: true,
    longDesc: 'A senior technology and software architect with 35 years of experience in both enterprise and startup environments, Tomi combines a focus on emerging technologies with a deep understanding of long-term system design. He is the author of the GALATI vitis software, a system used by winegrowers for over 30 years. He is also a co-founder of the OpenSlava conference and coaches and mentors software architects.',
    name: 'Tomi Vanek',
    photo: 'https://www.openslava.sk/images/2025/tomi_vanek_3a14d41e-6c58-4c70-8664-df48cfdc5524.jpg',
    shortDesc: 'A senior technology and sof...',
    order: 0,
    talks: ['e943bc0d-564b-4a59-8e27-5039e4ac5584']
  },
  {
    id: 'd4cd883b-d2fd-48a0-bc71-de704106898d',
    company: 'Wiz, Inc.',
    country: 'United Kingdom',
    featured: false,
    isConfirmed: true,
    longDesc: 'Joseph Hegarty leads the Wiz global Accenture business group.  For the last 20 years he has worked across multiple industries and technology companies, from start-ups to enterprises where one thing has remained a constant; his close relationship with Accenture.  Joseph has spent 20 years helping to build market defining offerings with Accenture to combine the best technologies with Accenture`s ability to deliver, operationalise, run and accelerate outcomes.  For the last 18 months, his focus has been on building the market leading offerings that Accenture and Wiz are taking to clients globally today.',
    name: 'Joseph Hegarty',
    photo: 'https://www.openslava.sk/images/2025/joseph_hegarty_d4cd883b-d2fd-48a0-bc71-de704106898d.jpg',
    shortDesc: 'Joseph Hegarty leads the Wi...',
    order: 0,
    talks: ['3045aa65-acd5-458c-b850-133de42ceb7f','68929559-08be-40ee-88d1-970761bdbb49']
  },
  {
    id: '8f6ed052-f005-4673-8df4-4d4e37a4657a',
    company: 'Accenture',
    country: 'Germany',
    featured: false,
    isConfirmed: true,
    longDesc: 'I am a GenAI strategist, innovator at heart, and reinventor by design. With a passion for shaping the future of technology, I focus on leveraging generative AI to transform how businesses operate, create, and compete. My work blends strategy with hands-on innovation, helping organizations reimagine possibilities and unlock new value. Always curious and forward-looking, I thrive on turning bold ideas into practical, impactful solutions.',
    name: 'Marcio Theme',
    photo: 'https://www.openslava.sk/images/2025/marcio_theme_8f6ed052-f005-4673-8df4-4d4e37a4657a.jpg',
    shortDesc: 'I am a GenAI strategist, in...',
    order: 0,
    talks: ['8c54e7bf-0937-438a-be83-80d2a2dd3232']
  },
  {
    id: '16a64f61-858a-43cb-b1e1-d3a6b185964e',
    company: 'Siemens Healthineers',
    country: 'Slovakia',
    featured: false,
    isConfirmed: true,
    longDesc: 'Nikita works as a penetration tester at Siemens Healthineers, assessing the security posture of various assets, ranging from web applications to hardware devices. He seeks to exploit quirky behaviors to uncover interesting vulnerabilities and leverage them in a full exploit chain. In his free time, Nikita focuses on Bug Bounty Hunting, contributing to the security of several companies, and conducting security research within the AppSec field. His research primarily focuses on parsings, encodings, and identifying discrepancies in systems. Additionally, Nikita participates in Capture The Flag (CTF) competitions along with Slovak National Cyber Team in preparation for the European Cybersecurity Tournament. When he finds more free time, he deepens his knowledge in Red Teaming TTPs and enjoys rock climbing.',
    name: 'Nikita Bohuslavskyi',
    photo: 'https://www.openslava.sk/images/2025/nikita_bohuslavskyi_16a64f61-858a-43cb-b1e1-d3a6b185964e.jpg',
    shortDesc: 'Nikita works as a penetrati...',
    order: 0,
    talks: ['fc3786d9-f848-4982-a9e7-2c8ef173c5e1']
  },
  {
    id: '326cd898-aa3f-48a0-8b14-260aa8cb2d39',
    company: 'Siemens Healthineers',
    country: 'Slovakia',
    featured: false,
    isConfirmed: true,
    longDesc: 'Ivan is experienced in many flavors of information security as he saw how the things are being done in multiple industries and world-renowned companies including Hewlett-Packard, KPMG, First Data (now Fiserv), VÚB Bank (part of Intessa Sanpaolo), Swiss Re, iptiQ and last but not least his current employer Siemens Healthineers. Always working in security-related occupations and coming from a technical background whilst trying to have an artistic and creative approach to solving problems he is always in search of something interesting to study. In his free time he likes to play badminton, write poetry and present it in front of people. Ivan proudly holds a Burp Suite Certified Practitioner certification which demonstrates a deep knowledge of web security vulnerabilities, the correct mindset to exploit them, and of course, the Burp Suite skills needed to carry this out. Speaking of free time it also took him a lot of that to finally complete it.',
    name: 'Ivan Oravec',
    photo: 'https://www.openslava.sk/images/2025/ivan_oravec_326cd898-aa3f-48a0-8b14-260aa8cb2d39.jpg',
    shortDesc: 'Ivan is experienced in many...',
    order: 0,
    talks: ['fc3786d9-f848-4982-a9e7-2c8ef173c5e1']
  },
  {
    id: '5304f9e8-d4e4-4938-bc70-7eb0f672e17a',
    company: 'Accenture',
    country: 'Slovakia',
    featured: false,
    isConfirmed: true,
    longDesc: 'Formerly a scientist, environmentalist, university lecturer, and NGO director. Currently a programmer, team leader, manager, and soft-skills trainer. Among other achievements, leader of the IT Project of the Year 2023. With over 20 years of experience in technologies around web applications, currently focusing on React, Node.js, Docker, Kubernetes, SQL, MongoDB, Redis, socket.io, IPFS, GenAI, Python and more.',
    name: 'Peter Baus',
    photo: 'https://www.openslava.sk/images/2025/peter_baus_5304f9e8-d4e4-4938-bc70-7eb0f672e17a.jpg',
    shortDesc: 'Formerly a scientist, envir...',
    order: 0,
    talks: ['6310c892-3749-4391-9804-3be272b46426']
  },
  {
    id: '5ee716ee-311f-49ee-8c3a-fdf6cb8b693f',
    company: 'Siemens Healthineers',
    country: 'Slovakia',
    featured: false,
    isConfirmed: true,
    longDesc: 'Boris is a Physicist at heart, mathematician by training, developer by trade, and AI expert through it all. Currently a Software Architect at Siemens Healthineers, dedicating the past 8 years to AI development, mostly in the medical domain. In combination with his background in hard sciences (math, physics, programming), he can connect intuition with reality, making the neural networks more explanatory and less “black box”. This approach is key to ensuring AI models meet regulatory requirements and achieve certification as medical devices.',
    name: 'Boris Vavrik',
    photo: 'https://www.openslava.sk/images/2025/boris_vavrik_5ee716ee-311f-49ee-8c3a-fdf6cb8b693f.jpg',
    shortDesc: 'Boris is a Physicist at hea...',
    order: 0,
    talks: ['36a1717a-fda4-414c-8082-1398ae1424b6']
  },
  {
    id: 'd03717b3-56c3-43fb-aaf9-09b70a5053de',
    company: 'Kempelen Institute of Intelligent Technologies',
    country: 'Slovakia',
    featured: false,
    isConfirmed: true,
    longDesc: 'Marcel Veselý is a Research Engineer at the Kempelen Institute of Intelligent Technologies (KInIT), where he has been working for over two years. He has a strong background in machine learning, deep learning, computer vision, and natural language processing. His work focuses on fine-tuning deep learning models for real-world customer use cases, with a particular emphasis on customizing large language models (LLMs) and AI agents to support specific business processes. With a blend of research expertise and practical implementation skills, he is dedicated to translating state-of-the-art AI advancements into impactful, scalable solutions for industry partners.',
    name: 'Marcel Veselý',
    photo: 'https://www.openslava.sk/images/2025/marcel_veselý_d03717b3-56c3-43fb-aaf9-09b70a5053de.jpg',
    shortDesc: 'Marcel Veselý is a Research...',
    order: 0,
    talks: ['252b5585-377b-4cb9-bc67-061ac961b408']
  },
  {
    id: 'fbe25268-f13c-44d5-9fcc-b919b72212e2',
    company: 'AI robocube ',
    country: 'Slovakia',
    featured: true,
    isConfirmed: true,
    longDesc: 'With a strong background in automation and digital transformation, Viktoria Bracjunova has led high-impact projects for global companies in logistics, retail, telecom, and manufacturing. As the CEO and co-founder of AI robocube, she focuses on accelerating automation delivery through a managed platform powered by RPA and Generative AI. Her experience spans building automation centers, scaling operations, and driving measurable business outcomes through technology. She is known for bridging the gap between business needs and technical solutions, helping organizations move from static bots to intelligent agents that deliver real value.',
    name: 'Viktoria Lukacova Bracjunova',
    photo: 'https://www.openslava.sk/images/2025/viktoria_lukacova bracjunova_fbe25268-f13c-44d5-9fcc-b919b72212e2.jpg',
    shortDesc: 'With a strong background in...',
    order: 55,
    talks: ['453c7680-77c9-474a-bfd3-d6d0a9a5122f','b551df52-2e09-4666-8cfc-b2becabd6819']
  },
  {
    id: '3b428ba1-29b9-485a-bb71-3a484d977bd8',
    company: 'Accenture',
    country: 'Czech Republic ',
    featured: true,
    isConfirmed: true,
    longDesc: 'Seba Hofer is a Cyber Risk Consultant and EBIOS RM expert, helping organizations identify threats and strengthen their security posture. She leads dynamic workshops that engage business and technical teams alike, making cyber risks tangible. Her approach helps turn awareness into concrete strategies for resilience.',
    name: 'Seba Hofer',
    photo: 'https://www.openslava.sk/images/2025/seba_hofer_3b428ba1-29b9-485a-bb71-3a484d977bd8.jpg',
    shortDesc: 'Seba Hofer is a Cyber Risk Consultant and EBIO...',
    order: 30,
    talks: ['3653f10a-0df9-41da-a8a0-fc41d1833a19']
  },
  {
    id: '9969e011-6c53-428d-b089-b4c1093fb4b9',
    company: 'Accenture',
    country: 'Ireland',
    featured: false,
    isConfirmed: true,
    longDesc: 'Javier Sastre is Analytics Innovation Principal at Accenture’s The Dock in Dublin, backed by 21 years of industry experience spanning NLP, broader AI and, lately, GenAI. He earned a joint PhD in Computational Linguistics through a cotutelle program between Université Paris-Est and the University of Alicante, where he developed efficient finite-state methods for language processing. Javier has since published applied research on dialog-flow mining and topic-description generation at venues such as SIGDIAL, showcasing his focus on practical NLP advances. He also co-invented patented techniques for descriptive topic modelling that underpin client solutions. Today he leads multidisciplinary teams turning cutting-edge models into rapid prototypes—from AI-assisted software delivery to deepfake detection—so businesses can validate ideas in days instead of months. Passionate about applied science, Javier thrives on bridging academic breakthroughs with real-world outcomes.',
    name: 'Javier Sastre',
    photo: 'https://www.openslava.sk/images/2025/javier_sastre_9969e011-6c53-428d-b089-b4c1093fb4b9.jpg',
    shortDesc: 'Javier Sastre is Analytics ...',
    order: 0,
    talks: ['4608586d-098e-430f-8051-75a418b650a7']
  },
  {
    id: '3e5197f2-60f8-4f13-a599-8374770e68e6',
    company: 'Accenture',
    country: 'France',
    featured: true,
    isConfirmed: true,
    longDesc: 'Mr Armando is Accenture`s Global Architecture lead. He has 30+ years of experience as a Technology and Enterprise Architect, and as a Business and Technology Reinventor.',
    name: 'Ezio Armando',
    photo: 'https://www.openslava.sk/images/2025/ezio_armando_3e5197f2-60f8-4f13-a599-8374770e68e6.jpg',
    shortDesc: 'Mr Armando is Accenture`s G...',
    order: 70,
    talks: ['8478d689-4cf9-4617-8bda-e4bdfc90715d']
  },
  {
    id: 'dae28908-c771-4756-bc70-dc3b47dbdd0a',
    company: 'Accenture',
    country: 'Slovakia',
    featured: true,
    isConfirmed: true,
    longDesc: 'Vladimir is technology architect from Slovakia, who has been working for 18 years on projects ranging from backend integration to large scale frontend portals in the cloud. He has also experience implementing artificial intelligence or IoT projects. At the moment he is acting as architect and leading several teams for banking projects.',
    name: 'Vladimir Hlavacek',
    photo: 'https://www.openslava.sk/images/2025/vladimir_hlavacek_dae28908-c771-4756-bc70-dc3b47dbdd0a.jpg',
    shortDesc: 'Vladimir is technology arch...',
    order: 45,
    talks: ['25b7a6df-3db6-47f1-9355-24aa09be10da']
  }
];

export default speakers;
